<template>
  <!-- Removido o v-if="show" para que o topo fique sempre visível -->
  <div>
    <v-row>
      <v-data-table
        :loading="is_loading"
        :headers="headers"
        :items="list"
        :items-per-page="10"
        class="elevation-1"
        style="width: 100%;"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Solicitações</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn @click="openDialog" color="primary" dark class="mb-2">
              Nova Solicitação
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:body="{ items }">
          <tbody v-if="items.length > 0">
            <tr v-for="(request, index) in items" :key="index">
              <td>
                <span> {{ mapMessage(request.requestType, requestTypes) }} </span>
              </td>
              <td>
                <span> {{ truncateText(request.observations) }} </span>
              </td>
              <td>
                <v-chip :style="getStatusStyle(request.status)">
                  {{ mapMessage(request.status, status) }}
                </v-chip>
              </td>
              <td>
                <!-- Colocar aqui o formatter!! -->
                <span> {{ request.createdByNameRole }} </span>
              </td>
              <td>
                <!-- Colocar aqui o formatter!! -->
                <span> {{ formatDateTime(request.lastModified) }} </span>
              </td>
              <td>
                <!-- Colocar aqui o formatter!! -->
                <span> {{ formatDateTime(request.createdAt) }} </span>
              </td>

              <td>
                <v-btn title="Visualizar" elevation="2" @click="() => viewRequest(index)" style="height: 30px; margin: 2px">
                  <v-icon color="primary" small> mdi-eye </v-icon>
                </v-btn>
                <v-btn title="Editar" elevation="2" @click="() => edit(index)" style="height: 30px; margin: 2px">
                  <v-icon color="primary" small> mdi-pencil </v-icon>
                </v-btn>
                <v-btn
                  title="Deletar"
                  elevation="2"
                  @click="() => confirmDeleteRequest(index)"
                  style="height: 30px; margin: 2px"
                  v-if="!isFranchisee"
                  :disabled="is_loading"
                >
                  <v-icon color="primary" small> mdi-delete </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="5" class="text-center">
                <v-icon md color="grey">mdi-alert</v-icon>
                <span>Nenhuma solicitação encontrada.</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-row>

    <v-form ref="form" v-model="validForm" lazy-validation>
      <v-dialog transition="dialog-top-transition" v-model="dialog" persistent max-width="750px">
        <v-card>
          <v-toolbar color="primary" dark>
            <span class="text-h5">{{dialogTitle}}</span>
          </v-toolbar>

          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text style="padding-bottom: 0px;">
                <v-row>
                  <v-select
                    :disabled="is_loading || isReadOnly || !canEditRequest"
                    :loading="is_loading"
                    v-model="request.requestType"
                    clearable
                    label="Tipo de Requisição"
                    :rules="rulesRequired"
                    :items="requestTypes"
                  ></v-select>
                </v-row>
                <v-row>
                      <v-textarea
                        label="Observações"
                        v-model="request.observations"
                        :loading="is_loading"
                        :disabled="is_loading || isReadOnly || !canEditRequest"
                        outlined
                      />
                </v-row>

                <v-row cols="12">
                  <v-col cols="10">
                    <span class="text-h6" style="margin-top: 13px">Documentos Anexados</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col>
                    <v-btn :disabled="!canEditRequest || isReadOnly" title="Adicionar novo documento" @click="addInputFile">
                      <v-icon>
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row cols="12">
                  <div style="display: flex; align-items: center; overflow-x: auto; white-space: nowrap; width: 100%;">
                    <v-col cols="5" v-for="(file, index) in files" :key="index">
                      <div style="display: flex; align-items: center; justify-content: end; width: 90%">
                        <v-btn :disabled="!canEditRequest || isReadOnly" @click="() => files.splice(index, 1)" color="red"><v-icon>mdi-close</v-icon></v-btn>
                      </div>
                      <InputFiles :disabled="!canEditRequest || isReadOnly" :fileTypes="['pdf', '/image']" :showFile="files[index]" :index="index"
                                  @change:file="(file) => (files[index] = file)" />
                    </v-col>
                  </div>
                </v-row>

              <v-divider v-if="files.length" class="border-opacity-100" />

            <v-col cols="12" v-if="showDecisionField">
              <v-row v-if="request.status !== 'under_review' || !isFranchisee">
                <v-col cols="4">
                  <h3>
                    Decisão
                  </h3>
                  <v-radio-group :disabled="isReadOnly || !canEditRequest" v-model="request.status">
                    <v-radio label="Aprovado" value="approved" />
                    <v-radio label="Revisão" value="under_review" />
                    <v-radio label="Reprovado" value="reproved" />
                  </v-radio-group>
                </v-col>

                <v-col cols="8">
                  <v-textarea
                    label="Observações da Decisão"
                    v-model="request.observationsDecision"
                    :loading="is_loading"
                    :disabled="is_loading || isReadOnly || !canEditRequest"
                    outlined
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" text @click="closeDialog" :loading="is_loading" :disabled="is_loading">
              Cancelar
            </v-btn>

            <v-btn
              color="blue darken-1"
              text
              @click="save"
              :loading="is_loading"
              :disabled="is_loading || disableSaveButton || !canEditRequest"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import InputFiles from '@/components/Forms/Input/input-files.vue';
import Rules from '@/utils/Rules';
import Utils from '@/scripts/Utils';
import { showErrorSnackBar, showSuccessSnackBar } from '@/utils/SnackBartHelper';
import { showDeleteDialogAlert } from '@/utils/DialogAlertHelper';
import cloneDeep from 'lodash/cloneDeep';
import { mapActions, mapGetters } from 'vuex';
import ContractRequestStorage from '@/services/storage/ContractRequestStorage';

const newRequest = () => {
  return {
    signedContractFile: [],
    requestType: null,
    observations: null,
    status: 'under_review',
    lastModified: null,
    observationsDecision: null,
  };
};

export default {
  name: 'Request',
  components: {
    InputFiles,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    add: {
      type: Function,
      default: (request, index) => {},
    },
    remove: {
      type: Function,
      default: index => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    idContract: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    is_loading: false,
    isReadOnly: false,
    validForm: true,
    dialog: false,
    disableSaveButton: false,
    dialogTitle: 'Nova Solicitação',
    index: -1,
    initialRequest: {},
    request: newRequest(),
    files: [],
    headers: [
      { text: 'Tipo de Requisição', value: 'requestType', width: '200' },
      { text: 'Observações', value: 'observations', width: '150' },
      { text: 'Status', value: 'statusRequest', width: '100' },
      { text: 'Criado Por', value: 'createdByNameRole' },
      { text: 'Criado Em', value: 'createdAt' },
      { text: 'Última Modificação', value: 'lastModified' },
      {},
    ],
    status: [
      { text: 'Revisão Solicitada', value: 'review_requested' },
      { text: 'Em Revisão', value: 'under_review' },
      { text: 'Reprovado', value: 'reproved' },
      { text: 'Aprovado', value: 'approved' },
    ],
    requestTypes: [
      { text: 'Alteração de Contrato', value: 'contract_review' },
      { text: 'Contrato Assinado', value: 'signed_contract' },
      { text: 'Contrato Inicial', value: 'start_contract' },
      { text: 'Outros', value: 'others' },
      { text: 'Declinado', value: 'refused_contract' },
    ],
  }),
  computed: {
    ...mapGetters(['getCurrentUser', 'getCurrentUserRank']),
    rulesRequired() {
      return Rules.required();
    },
    isFranchisee() {
      return this.getCurrentUserRank === 'Franqueado';
    },

    disableWhenReviewing() {
      return status => status === 'review_requested';
    },
    showDecisionField() {
      return !this.isFranchisee || (this.isFranchisee && this.request.status !== 'review_requested');
    },
    canEditRequest() {
      return (this.isFranchisee && this.request.status === 'under_review') || !this.isFranchisee;
    },
  },
  methods: {
    addInputFile() {
      const newFile = {
        name: null,
        file: null,
      }
      this.files.unshift(newFile);
    },
    truncateText(text, maxLength = 10) {
      if (text && text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
      }
      return text;
    },
    async checkIfExistsRequestsImagesToSave(idContract, request, files = []) {
      if (files.length) {
        const allowedTypes = [
          'application/pdf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ];
        if (this.initialRequest?.signedContractPath && this.initialRequest?.signedContractPath.length) {
          const isArrayOfStrings = Array.isArray(this.initialRequest?.signedContractPath);

          const paths = isArrayOfStrings
              ? this.initialRequest.signedContractPath
              : [this.initialRequest.signedContractPath];

          for (let file of paths) {
            await ContractRequestStorage.deleteImg(file);
          }
          request.signedContractPath = [];
        }

        request.signedContractPath = []

        for (const file of files) {
          const filePath = await ContractRequestStorage.uploadFile(idContract, file);
          request.signedContractPath.push(filePath);
        }

        delete request.signedContractFile;
      } else {
        const isArrayOfStrings = Array.isArray(request.signedContractPath);

        const paths = isArrayOfStrings
            ? request.signedContractPath
            : [request.signedContractPath];

        for (const file of paths) {
          if (file) {
            await ContractRequestStorage.deleteImg(file);
          }
        }
        request.signedContractPath = [];
        this.files = [];
      }
    },
    getStatusStyle(status) {
      const styles = {
        review_requested: { background: '#0578be', color: '#FFF' },
        under_review: { background: '#FFFF00', color: '#000' },
        approved: { background: '#228B22', color: '#FFF' },
        reproved: { background: '#FF0000', color: '#FFF' },
      };

      return {
        ...styles[status],
      };
    },
    async viewRequest(index) {
      this.is_loading = true;
      this.dialogTitle = "Visualizar Solicitação";
      const request = cloneDeep(this.list[index]);
      this.dialog = true;
      this.index = index;
      this.files = []
      this.request = cloneDeep(request);
      if (this.request.signedContractPath && this.request.signedContractPath?.length > 0) {
        const paths = Array.isArray(this.request.signedContractPath)
            ? this.request.signedContractPath
            : [this.request.signedContractPath];
        for (const file of paths) {
          this.files.push(await ContractRequestStorage.downloadImg(file));
        }
      }
      this.isReadOnly = true;
      this.disableSaveButton = true;
      this.is_loading = false;
    },
    async edit(index) {
      this.is_loading = true;
      this.dialogTitle = "Editar Solicitação";
      this.initialRequest = cloneDeep(this.list[index]);
      const request = cloneDeep(this.list[index]);
      this.dialog = true;
      this.index = index;
      this.files = []
      this.request = cloneDeep(request);
      if (this.request.signedContractPath?.length && this.request.signedContractPath) {
        const paths = Array.isArray(this.request.signedContractPath)
            ? this.request.signedContractPath
            : [this.request.signedContractPath];
        for (const file of paths) {
          this.files.push(await ContractRequestStorage.downloadImg(file));
        }
      }
      this.isReadOnly = false;
      this.disableSaveButton = false;
      this.is_loading = false;
    },
    mapMessage(value, list) {
      const mapped = list.find(item => item.value === value);
      return mapped ? mapped.text : 'Não definido';
    },
    formatDateTime(date) {
      if (date['seconds'] !== undefined && date['nanoseconds'] !== undefined) {
        return Utils.formatDateDayJs(date['seconds'] * 1000 + date['nanoseconds'] / 1e6, 'DD/MM/YYYY [às] HH:mm');
      } else {
        return Utils.formatDateDayJs(new Date(date), 'DD/MM/YYYY [às] HH:mm');
      }
    },
    openDialog() {
      this.index = -1;
      this.request = newRequest();
      this.files = [];
      this.initialRequest = {};
      this.dialogTitle = "Nova Solicitação";
      this.isReadOnly = false;
      this.disableSaveButton = false;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      const files = this.files.filter(file => file !== null && file !== undefined && file !== '');

      if (!files.length && this.request.requestType === 'signed_contract') {
        showErrorSnackBar('O contrato assinado é necessário para esse tipo de requisição!');
        return;
      }

      if (
        this.request.requestType === 'contract_review' &&
        (!this.request.observations || this.request.observations.trim().length === 0)
      ) {
        showErrorSnackBar('A Observação é necessária!');
        return;
      }

      if (this.index < 0) {
        this.request.createdByNameRole = this.getCurrentUser.currentUser.name;
        this.request.createdById = this.getCurrentUser.currentUser.id;
        this.request.createdAt = new Date();
      }
      this.request.lastModified = new Date();

      this.is_loading = true;
      await this.checkIfExistsRequestsImagesToSave(this.idContract, this.request, files);
      this.add({ ...this.request }, this.index);

      this.is_loading = false;
      this.dialog = false;
    },
    async confirmDeleteRequest(index) {
      showDeleteDialogAlert('Deseja excluir a requisição?', async ()  => {
        await this.checkIfExistsRequestsImagesToSave(this.idContract, this.request);
        this.remove(index);
      });
    },
  },
  watch: {
    list: {
      deep: true,
      handler: function(newValue) {
        if (newValue) {
          this.items = newValue;
        }
      },
    },
  },
};
</script>

<style scoped></style>
